import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Optional,
  Output,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";

import { NzTheadComponent } from "ng-zorro-antd/table";
import { UiTrDirective } from "@webapp/ui/table/directives/table/tr.directive";
import { UiThAddOnComponent } from "@webapp/ui/table/components/cell/th-addon/th-addon.component";
import { UiTableDataService } from "@webapp/ui/table/services/table-data.service";
import { UiTableStyleService } from "@webapp/ui/table/services/table-style.service";

@Component({
  selector: "thead:not(.ant-table-thead)",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "thead.component.html",
})
export class UiTheadComponent<T> extends NzTheadComponent<T> {
  @Output("uiSortOrderChange") public readonly nzSortOrderChange = new EventEmitter<{ key: NzSafeAny; value: string | null }>();

  @ViewChild("contentTemplate", { static: true }) public templateRef!: TemplateRef<NzSafeAny>;
  @ContentChildren(UiTrDirective, { descendants: true }) public listOfNzTrDirective!: QueryList<UiTrDirective>;
  @ContentChildren(UiThAddOnComponent, { descendants: true }) public listOfNzThAddOnComponent!: QueryList<UiThAddOnComponent<T>>;

  constructor(elementRef: ElementRef, renderer: Renderer2, @Optional() uiTableStyleService: UiTableStyleService, @Optional() uiTableDataService: UiTableDataService<T>) {
    super(elementRef, renderer, uiTableStyleService, uiTableDataService);
  }
}
